import { useEffect, useState } from "react";
import { api } from "../lib/api-client.js";

export interface ActivityType {
	type: string;
	category: string;
	display_name: string;
	description: string;
}

interface ActivityTypesState {
	types: ActivityType[];
	loading: boolean;
	error: string | null;
	retry: () => void;
}

export function useActivityTypes(): ActivityTypesState {
	const [types, setTypes] = useState<ActivityType[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [retryCount, setRetryCount] = useState(0);

	// biome-ignore lint/correctness/useExhaustiveDependencies: retryCount intentionally triggers re-fetch
	useEffect(() => {
		setLoading(true);
		setError(null);
		api
			.get<{ types: ActivityType[] }>("/activities/types")
			.then((res) => {
				setTypes(res.types);
				setLoading(false);
			})
			.catch((err) => {
				setError(err instanceof Error ? err.message : "Failed to load activity types");
				setLoading(false);
			});
	}, [retryCount]);

	return { types, loading, error, retry: () => setRetryCount((c) => c + 1) };
}
